import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IUserContext } from 'src/app/common/common-model';

import {Location} from '@angular/common';
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  headerTitle: string = 'Urban Tree Information System - Scheme Dashboard';
  userName: string = '';
  loginTimeStamp: string = '';
  Usertyp: string ='';
  UserDesc: string ='';
  elem:any;

  constructor(private route: Router,private _location: Location,private spinner: NgxSpinnerService) {
   
  }

  ngOnInit(): void {
    console.log(this.route.url)
    this.elem = document.documentElement;
    let data = sessionStorage.getItem('userContext');
    this.Usertyp =String(sessionStorage.getItem('Usertype')) ;
    this.UserDesc =String(sessionStorage.getItem('DesignationName')) ;
    console.log(this.Usertyp);
    if (data !== null) {
      let userDetails: IUserContext[] = data !== null ? JSON.parse(data) : null;
      this.userName = 'Welcome ' + userDetails[0].FirstName;
      this.loginTimeStamp = new Date().toString();
    } else {
      this.userName = '';
      this.loginTimeStamp = '';
    }
  }

  goBack() {
    this._location.back();
  }

  routelink(routekey:string)
  {
    console.log(routekey)
    this.route.navigateByUrl(routekey);
   // this._location.back();
  }

  routelink1(routekey:string)
  {
    //window.location.reload()
    console.log(this.route.url)  
   this.route.navigate(['/']);
 
  }

  signOut() {
    sessionStorage.clear();
    this.route.navigate(['']);
  }

  openFullscreen() {
    if (this.elem.requestFullscreen) {
      this.elem.requestFullscreen();
    } else if (this.elem.mozRequestFullScreen) {
      /* Firefox */
      this.elem.mozRequestFullScreen();
    } else if (this.elem.webkitRequestFullscreen) {
      /* Chrome, Safari and Opera */
      this.elem.webkitRequestFullscreen();
    } else if (this.elem.msRequestFullscreen) {
      /* IE/Edge */
      this.elem.msRequestFullscreen();
    }
  }
}
